import v2_getSpent_action from "src/actions/v2/cliente/v2.getSpent.action"
import v2_getSpentMeses_action from "src/actions/v2/cliente/v2.getSpentMeses.action"


export const getSpent = async (clienteId, querys) => {
    try {

        const response = await v2_getSpent_action(clienteId, querys)
        if(response.status === 200) {
            return response.data
        }
    } catch(error) {
        console.log('erro ao transferir chat')
    }

}

export const getSpentMeses = async (clienteId) => {
    try {

        const response = await v2_getSpentMeses_action(clienteId)
        if(response.status === 200) {
            return response.data
        }
    } catch(error) {
        console.log('erro ao buscar consumo por mes')
    }

}

